export enum ELEMENT_TYPES {
  "IFRAME" = "IFRAME",
  "TEXT" = "TEXT",
  "LINK" = "LINK",
  "SCREENSHARE" = "SCREENSHARE",
  "IMAGE" = "IMAGE",
}

export enum SLIDE_TEMPLATES {
  "START_PAGE" = "START_PAGE",
  "TEXT_IMAGE" = "TEXT_IMAGE",
  "IMAGE_2TEXT" = "IMAGE_2TEXT",
  "PLAIN_TEXT" = "PLAIN_TEXT",
}

export enum OBJECT_FIT {
  "CONTAIN" = "CONTAIN",
  "COVER" = "COVER",
}

export enum TEXT_ALIGN {
  "START" = "START",
  "CENTER" = "CENTER",
  "END" = "END",
}

export enum ROLE {
  "ADMIN" = "ADMIN",
  "COLLABORATOR" = "COLLABORATOR",
  "GUEST" = "GUEST",
}

export enum CONNECTION_STATUS {
  "NORMAL" = "NORMAL",
  "ERROR" = "ERROR",
  "RECONNECTING" = "RECONNECTING",
}

export interface Image {
  cdnUrl: string;
  height: number;
  width: number;
}

export enum PLOT_MODE {
  "VIEW_ALL" = "VIEW_ALL",
  "NO_ACCESS" = "NO_ACCESS",
}

export enum PLOT_THEME {
  "BLACK" = "BLACK",
  "LIGHT" = "LIGHT",
  "BLUE" = "BLUE",
  "YELLOW" = "YELLOW",
}

export interface Pos {
  x: number;
  y: number;
}

export interface Size {
  w: number;
  h: number;
}

export interface ElementBase {
  id: string;
  type: ELEMENT_TYPES;
  pos: Pos;
  size: Size;
}

export type Position = {
  x: number;
  y: number;
};

export interface TextElementData {
  content: string;
  align: TEXT_ALIGN;
  timestamp: number;
}

export interface TextElement extends ElementBase {
  data: TextElementData;
}

export interface ImageElementData {
  cdnUrl: string;
  objectFit: OBJECT_FIT;
  background: string;
  height: number;
  width: number;
}

export interface ImageElement extends ElementBase {
  data: ImageElementData;
}

export interface IframeElementData {
  url: string;
}

export interface IframeElement extends ElementBase {
  data: IframeElementData;
}

export interface ParticipantCursor {
  pos: Pos;
  identityId: string;
}

export type RoomElement = IframeElement | ImageElement | TextElement;

export interface Room {
  roomId: string;
  component: string;
  name: string;
  capacity: number;
  elements: RoomElement[];
}

export interface ElementUpdate {
  id: string;
  pos?: Pos;
  size?: Size;
  data?: ImageElementData | TextElementData | IframeElementData;
}
